import React from 'react';

import MapComponent from './components/MapComponent';
import './App.css';  // Global app styles

const App = () => {
  return (
    <div className="app">

      <MapComponent />
    </div>
  );
};

export default App;
